import { render, staticRenderFns } from "./Plan2.vue?vue&type=template&id=62082fb2"
import script from "./Plan2.vue?vue&type=script&lang=js"
export * from "./Plan2.vue?vue&type=script&lang=js"
import style0 from "./Plan2.vue?vue&type=style&index=0&id=62082fb2&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62082fb2')) {
      api.createRecord('62082fb2', component.options)
    } else {
      api.reload('62082fb2', component.options)
    }
    module.hot.accept("./Plan2.vue?vue&type=template&id=62082fb2", function () {
      api.rerender('62082fb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/section/Plan2.vue"
export default component.exports